import { Box } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  removeCkAttachedFile,
  removeEsignAttachedFile,
  resetSelectFile,
  selecteFileStatus
} from '../../Store/Redux/FileListSlice';
import { useQueryParameters } from './useQueryParameters';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { deleteCkAttachedFile, removeAttachmentEsignAPI } from '../../Services/APIConfig';

function DocumentNameWrapper({
  isMobile,
  ckattchment,
  file,
  documentName,
  setOpenPDF,
  setSelectedFile,
  width,
  setDropzoneEnabled,
  setErrorMessage,
  showDownloadOptions = false
}) {
  const { getParameter } = useQueryParameters();
  const createmode = getParameter('createmode');
  const fileId = getParameter('fileId');
  const { documentID } = useSelector(state => state.newesign);
  const selectedFile = useSelector(state => state.fileList.selectedFile);

  const handleOpenPDF = fileData => {
    setSelectedFile(fileData);
    setOpenPDF(true);
    dispatch(selecteFileStatus({ ...fileData, showDownloadOptions }));
  };

  const dispatch = useDispatch();

  const handleRemoveFile = async file => {
    if (ckattchment) {
      if (createmode === 'true') {
        // remove attachfile

        await deleteCkAttachedFile(fileId, file.id);
      }
      if (createmode === 'false') {
        if (selectedFile !== null && selectedFile.length > 0) {
          selectedFile.forEach(async item => {
            await removeAttachmentEsignAPI(item?.docId, file.id);
          });
        } else {
          await removeAttachmentEsignAPI(documentID, file.id);
        }
      }
      if (setDropzoneEnabled) {
        setDropzoneEnabled(true);
        if (setErrorMessage) {
          setErrorMessage('');
        }
      }
    }
    dispatch(removeCkAttachedFile(file.id));

    if (createmode === 'false') {
      dispatch(removeEsignAttachedFile(file.id));
    }
    // } else {
    //   dispatch(resetSelectFile(id));
    //   dispatch(selecteFileStatus(null));
    // }
  };

  return (
    <Box
      mt={isMobile ? 1 : 2}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'space-between'}
      rowGap={1}
      columnGap={isMobile ? 0 : 1.5}
      marginRight={isMobile ? 0 : 1.5}
      sx={{
        borderRadius: '8px',
        background: '#ECF0E5',
        padding: isMobile ? '10px' : '14px',
        width: width || 'auto'
      }}
    >
      <div
        className={isMobile ? 'medium5' : 'medium4'}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          color: '#21241E',
          textOverflow: 'ellipsis',
          maxWidth: isMobile ? 'auto' : 180
        }}
      >
        {documentName}
      </div>
      <Box display={'flex'} alignItems={'center'} columnGap={1.5}>
        <div
          className={isMobile ? 'medium7 pdf-view_btn pointer-css' : 'medium5 pdf-view_btn pointer-css'}
          onClick={() => handleOpenPDF(file)}
        >
          View
        </div>

        {ckattchment && file.enableDelete && (
          <div onClick={() => handleRemoveFile(file)} className='pointer-css'>
            <HighlightOffIcon color='#21241E' sx={{ opacity: 0.3, fontSize: 26, cursor: 'pointer' }} />
          </div>
        )}
      </Box>
    </Box>
  );
}

export default DocumentNameWrapper;
